<template>
    <v-app id="app" class="application">
        <!--loader-->
        <div v-if="display_loader" class="cts_loader">
            <img width="148px" src="/assets/images/icons/loader.svg" />
            <p>{{ $t("res_Msgs_LoadingText") }}</p>
        </div>

        <div id="menu">
            <div v-if="isLoggedIn" class="d-flex justify-space-between gap-3  p-4 align-center">
                <div class="d-flex align-end gap-3">
                    <v-img :src="'/assets/images/logos/' + client_logo_name" max-height="100"  max-width="300Px" />
                    <span class="text-h6 font-weight-medium" style="color: var(--primary-button-color);">{{ $t("res_Title_CorrespondenceManagementSystem") }}</span>
                </div>
                <div class="d-flex justify-end gap-2">
                    <!-- lang switch btn -->
                    <div class="margin-right-l" style="text-align: center;">
                        <v-btn style="padding:0; width:40px;" @click="changeRTL(true)" v-if="isLanguageEn"
                            class="dgs-new-button-inner">
                            <v-icon color="#024976"> mdi-abjad-arabic </v-icon>
                        </v-btn>
                        <v-btn style="padding:0; width:40px;" @click="changeRTL(false)" v-if="!isLanguageEn"
                            class="dgs-new-button-inner">
                            <v-icon color="#024976"> mdi-abugida-devanagari </v-icon>
                        </v-btn>
                    </div>
                    <div>
                        <v-btn @click="logout"><v-icon>mdi-logout</v-icon>
                       </v-btn>
                    </div>
                </div>
            </div>
        </div>
        <router-view />
        <!-- </section> -->
        <v-dialog v-model="informationDialog" content-class="small-dialog" width="500" height="350">
            <v-card>
                <v-card-title>
                    <span>{{ information_heading }}</span>
                </v-card-title>
                <div class="card-body">
                    <label>{{ information_text }}</label>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" width="100" @click="informationDialogContinue">{{
                        $t("res_ButtonText_Continue")
                    }}</v-btn>
                    <v-btn color="light-blue" width="100" @click="informationDialogCancel">{{
                        $t("res_ButtonText_Cancel")
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div v-if="display_loader" class="cts_loader">
            <img width="148px" src="/assets/images/icons/loader.svg" />
            <p>{{ $t("res_Msgs_LoadingText") }}</p>
        </div>
        <div class="alerts-box">
            <v-alert v-for="(snackbar, index) in snackbars" v-if="snackbar.show" text :key="index"
                @click="hideAlert(snackbar)" :type="snackbar.type" class="mt-1">
                {{ snackbar.text }}
            </v-alert>
        </div>
        <v-alert v-if="snackbar_show" text :type="snackbar_type">
            {{ snackbar_text }}
        </v-alert>
    </v-app>
</template>

<script>
import jwt_decode from 'jwt-decode';
import DWT from './components/DWT'
import axios from 'axios'
import constants from './assets/js/constants'
import MultiSelect from 'vue-multiselect'
import { mapGetters, mapActions } from 'vuex'
import router from './router/index.js'
import draggable from "vuedraggable"
import * as utils from './assets/js/common.js'
import MessagesUtil from '@/utils/messagesUtil'
import Multiselect from 'vue-multiselect'
import CTSFileService from '@/assets/js/CTSFileService/CTSFileService.js';
import uploadChunkService from '@/assets/js/CTSFileService/uploadChunkService.js';
import Menu from '@/components/Menu.vue'
export default {
    name: 'App',
    components: {
        DWT, MultiSelect, draggable, Multiselect,
        Menu
    },
    data: () => ({
        createByFileTitle: '',
        createIncomingDialog: false,
        isShow: false,
        loading: false,
        isAuthenticated: false,
        isLanguageEn: true,
        user: null,
        profileDialog: false,
        userDisplayName: '',
        userId: 0, //JSON.parse(sessionStorage.getItem("user")).profile.Id,
        userEmail: '',
        userAbbreviation: '',
        userAbbreviationSrc: '',
        manageUserSignaturesDialog: false,
        refreshToken: '',
        expandSearch: false,
        AssignedTaskCount: 0,
        searchQuery: '',
        display_loader: false,
        snackbar_show: false,
        snackbar_text: '',
        snackbar_type: '',
        informationDialog: false,
        information_heading: '',
        information_text: '',
        information_continueHandler: null,
        information_cancelHandler: null,
        information_SavecontinueHandler: null,
        dateTimeOptions: {
            year: "numeric",
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        },
        dateOptions: {
            year: "numeric",
            month: '2-digit',
            day: '2-digit'
        },

        constants: constants,
        router: router,
        messagesUtil: MessagesUtil,
        showLoadingCount: 0,
        client_logo_name: client_logo_name,
        systemNotificationList: [],
        SystemNotificationDialog: false,
        correspondenceDialogOpened: false,
        correspondenceDialogObject: {
            documentId: 0,
            transferId: 0,
            viewMode: 'edit',
            delegationId: 0,
            toEmail: "",
            emailCC: "",
            closeDialogEvent: 0,
            openedFromNodeId: 2,
        },
        utils: utils,
        menuItems: [],
        defaultApplicationId: 2,
        selectedItem: null,
        selected: [],
        priorities: [],
        from_date_datePicker: false,
        to_date_datePicker: false,
        hideElasticSearch: window.hideElasticSearch,
        hideOpenAdvancedSearchFiltersFromHomePage: window.hideOpenAdvancedSearchFiltersFromHomePage,
        TaskDetailsDialogOpened: false,
        TaskProjecDialogOpened: false,
        taskDialogObject: {
            linkedWithProject: true,
            selectedTaskId: 0,
            projectId: 0,
            isProjectCreator: false,
            isPublic: false
        },
        // isNeedResetSignaturePin: false,
        isCompletedProfile: false,
        snackbars: [],

    }),
    async created() {
        this.setRtl();
        this.initializeUserData();
    },
    beforeMount() {
        window.documentView = {}
        window.showAlert = this.showAlert
        window.showLoading = this.showLoading
        window.hideLoading = this.hideLoading
        window.newDate = this.newDate
        window.dateFormatForExternlUse = utils.dateFormat;
        window.showInformation = this.showInformation
        window.translate = this.translate
        window.dateTimeOptions = this.dateTimeOptions
        window.dateOptions = this.dateOptions
        window.setViewerData = this.setViewerData;
        window.getViewerData = this.getViewerData;
        window.getLocalizedVal = this.getLocalizedVal;
        window.showInformationWithSave = this.showInformationWithSave
        window.ActiveNotification = this.ActiveNotification
        window.CTSFileService = CTSFileService;
        window.uploadChunkService = uploadChunkService;
        window.setConfigureSignatureData = this.setConfigureSignatureData;

    },
    mounted() {

        var appContext = this;
        this.priorities = constants.priorities;
        setInterval(function () {
            if (document.getElementsByClassName('bottom-action-bar').length > 0)
                document.body.classList.add('alert-top')
            else
                document.body.classList.remove('alert-top')
        }, 1000)




        if (constants.disclaimerMessage != null && constants.disclaimerMessage != undefined && constants.disclaimerMessage != '') {
            this.addFloatingDisclaimer(constants.disclaimerMessage)
        }
        //var user = JSON.parse(sessionStorage.getItem("user"))
        //this.userId = user.profile.Id
        // this.isNeedResetSignaturePin = user.profile.IsNeedResetSignaturePin//need to complete the profile
        //this.isCompletedProfile = user.profile.isCompletedProfile;


    },
    //computed: mapGetters(['allUserStructures']),
    computed: {
        // Check if the user is logged in by verifying the userId
        isLoggedIn() {
            const loggedIn = !!this.userId && this.userId !== '' && this.userId !== '0';
            console.log("isLoggedIn computed - userId:", this.userId, "result:", loggedIn);
            return loggedIn;
        },
    },
    watch: {
        $route: {
            handler(to, from) {
                // Re-initialize user data when route changes
                this.initializeUserData();
            },
            immediate: false
        }
    },
    beforeDestroy() {
        this.clearNotificationsTimer();
    },
    methods: {
        initializeUserData() {
            var user = localStorage.getItem("user");
            console.log("initializeUserData - token exists:", !!user);
            if (user) {
                try {
                    this.decodedToken = jwt_decode(user);
                    this.userId = this.decodedToken.DSUserId || this.decodedToken.userId || this.decodedToken.sub;
                    this.userDisplayName = this.decodedToken.DisplayName || this.decodedToken.displayName || this.decodedToken.name || '';
                    console.log("User initialized - userId:", this.userId, "displayName:", this.userDisplayName);
                } catch (error) {
                    console.error("Error decoding token:", error);
                    this.userId = '';
                    this.userDisplayName = '';
                    localStorage.removeItem('user');
                }
            } else {
                this.userId = '';
                this.userDisplayName = '';
            }
        },
        logout() {
            // Clear the token and redirect to login
            localStorage.removeItem('user');
            this.userId = '';
            this.userDisplayName = '';
            this.$router.push({ name: 'login' });
            window.location.reload();
        },
        setConfigureSignatureData(documentId, attachmentId) {
            sessionStorage.setItem("config_swq_id1", documentId);
            sessionStorage.setItem("config_swq_id2", attachmentId);
        },
        closeDocumentDetailsDialog() {
            this.selectedDocumentId = 0;
            this.createIncomingDialog = false;
        },
        setViewerData(id, documentId, versionId, fileName, fromLinkedDocumentId, transferId) {
            var viewerInstanceId = utils.generateGUID();

            var viewerDataItem = {
                viewerInstanceId: viewerInstanceId,
                data: [{ key: 'id', value: id }, { key: 'documentid', value: documentId }]
            };

            if (transferId) {
                viewerDataItem.data.push({ key: 'transferid', value: transferId });
            }

            if (versionId) {
                viewerDataItem.data.push({ key: 'versionid', value: versionId });
            }

            if (fileName) {
                viewerDataItem.data.push({ key: 'filename', value: fileName });
            }

            if (fromLinkedDocumentId) {
                viewerDataItem.data.push({ key: 'fromlinkeddocumentid', value: fromLinkedDocumentId });
            }

            // viewerDataItem.data.push({ key: 'hasaccessforviewstamps', value: constants.userActions.toolbarMenu.some(x => x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.ApplyViewerStamps.key) });

            if (!this.viewerData) {
                this.viewerData = []
            }

            this.viewerData.push(viewerDataItem);

            return viewerInstanceId;
        },
        getViewerData(key, viewerInstanceId) {
            if (this.viewerData) {
                if (key)
                    key = key.toLowerCase()

                var viewerDataItem = this.viewerData.filter(x => x.viewerInstanceId == viewerInstanceId)[0]

                let item = viewerDataItem.data.filter(x => x.key == key)[0];

                if (item)
                    return item.value
            }

            return null
        },
        isExternalLink(to) {
            return typeof to === 'string' && (to.startsWith('http') || to.startsWith('https'))
        },
        closeTaskDetailsDialog() {
            this.taskDialogObject = {};
            this.TaskDetailsDialogOpened = false;
            this.TaskProjecDialogOpened = false;
        },
        closeTaskProjectDialog() {
            this.taskDialogObject = {};
            this.TaskDetailsDialogOpened = false;
            this.TaskProjecDialogOpened = false;
        },


        openAddSignatureDialog() {
            console.log('true');
            this.isSignatureModelShow = true;
        },
        openProfileBox() {
            var user = JSON.parse(sessionStorage.getItem("user"))
            if (user != null && user != undefined) {
                this.userDisplayName = user.profile.DisplayName;
                this.userId = user.profile.Id
                this.userEmail = user.profile.Email
            }
            this.profileDialog = !this.profileDialog
        },
        hasPermission(name) {
            // if (constants.userActions && constants.userActions.features) {
            //     return constants.userActions.features.some(f => f.name.toLowerCase() == name.toLowerCase());
            // }

            return true;
        },

        async changeRTL(direction) {
            this.showLoading();
            this.isLanguageEn = direction ? false : true;
            this.$i18n.locale = direction ? 'ar' : 'en'
            this.$vuetify.rtl = direction
            // sessionStorage.setItem('lang', direction ? 'ar' : 'en')
            localStorage.setItem('lang', direction ? 'ar' : 'en');
           setTimeout(() => {
            window.location.reload(); }, 150);
        },
        setRtl() {
            var isDirectionRtl = localStorage.getItem('lang') == 'ar' ? true : false;
            this.isLanguageEn = isDirectionRtl ? false : true;
            this.$i18n.locale = isDirectionRtl ? 'ar' : 'en';
            this.$vuetify.rtl = isDirectionRtl;
        },

        showAlert(text, type) {
            var textValue = this.translate(text)
            this.snackbar_text = this.translate(textValue);
            this.snackbar_type = type;
            this.snackbar_show = true;
            setTimeout(() => {
                this.snackbar_show = false;
            }, 3000);
        },
        showInformation(heading, text, continueHandler, cancelHandler) {
            this.information_SavecontinueHandler = null;
            this.information_heading = this.translate(heading)
            this.information_text = this.translate(text)
            this.information_continueHandler = continueHandler
            this.information_cancelHandler = cancelHandler
            this.informationDialog = true
        },
        showInformationWithSave(heading, text, continueHandler, cancelHandler, savecontinueHandler) {
            this.information_SavecontinueHandler = null;
            this.information_heading = this.translate(heading)
            this.information_text = this.translate(text)
            this.information_continueHandler = continueHandler
            this.information_cancelHandler = cancelHandler
            this.information_SavecontinueHandler = savecontinueHandler;
            this.informationDialog = true
        },
        informationDialogCancel() {
            this.informationDialog = false
            if (this.information_cancelHandler != null)
                this.information_cancelHandler()
        },
        informationDialogContinue() {
            this.informationDialog = false
            if (this.information_continueHandler != null)
                this.information_continueHandler()
        },
        informationDialogSaveContinue() {
            this.informationDialog = false
            if (this.information_SavecontinueHandler != null)
                this.information_SavecontinueHandler()
        },
        showLoading() {
            this.display_loader = true
            this.showLoadingCount++;
        },
        hideLoading() {
            this.showLoadingCount--;
            if (this.showLoadingCount < 1) {
                this.showLoadingCount = 0;
                this.display_loader = false
            }
        },
        newDate() {
            return new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000);
        },
        clearSearchResult() {
            this.expandSearch = false;
            this.searchQuery = '';
            this.navigateToMyTasksAndSearch();
        },




        translate(text) {
            try {
                if (this.$i18n.locale == 'en')
                    return this.$i18n._getMessages().en[text] == null ? text : this.$i18n._getMessages().en[text]
                else
                    return this.$i18n._getMessages().ar[text] == null ? text : this.$i18n._getMessages().ar[text]
            } catch (ex) {
                //console.log(ex)
            }
        },
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str)
        },
        GetMultiSelectSubHeaderDisplay(options) {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        getLocalizedVal(enVal, arVal) {
            if (this.$i18n.locale == 'ar' && arVal) {
                return arVal;
            }

            return enVal;
        },

        GetAllSystemNotifications() {
            axios.get(constants.baseApiUrl + 'SystemNotification/GetAllSystemNotifications?applicationId=' + this.defaultApplicationId)
                .then(response => {
                    if (response.data != null && response.data != undefined)
                        this.systemNotificationList = response.data
                })
                .catch(error => console.log(error));
        },
        OpenSystemNotificationsDialog() {
            this.GetAllSystemNotifications();
            this.SystemNotificationDialog = !this.SystemNotificationDialog
        },
        MakeSystemNotificationIsDismissed(item) {
            window.showLoading()
            axios.get(constants.baseApiUrl + 'SystemNotification/SystemNotificationIsDismissed?SystemNotificationId=' + item.id + '&applicationId=' + this.defaultApplicationId)
                .then(response => {
                    window.hideLoading();
                })
                .catch(error => console.log(error));

            this.systemNotificationList.splice(this.systemNotificationList.findIndex(i => i.id === item.id), 1)
        },
        clearAllNotification(item) {
            window.showLoading()
            axios.get(constants.baseApiUrl + 'SystemNotification/SystemNotificationReadAll')
                .then(response => {
                    window.hideLoading();
                    this.GetAllSystemNotifications();
                })
                .catch(error => console.log(error));
        },

        openNotification(item) {
            window.showLoading();
            axios.get(constants.baseApiUrl + 'SystemNotification/SystemNotificationIsRead?SystemNotificationId=' + item.id + '&applicationId=' + this.defaultApplicationId)
                .then(response => {
                    window.hideLoading()
                    let index = this.systemNotificationList.findIndex(i => i.id == item.id);
                    this.systemNotificationList[index].isRead = true;
                })
                .catch(error => console.log(error));
            if (this.defaultApplicationId == 2)
                this.OpenTaskNotification(item)
            else
                this.OpenSystemNotification(item)
        },
        OpenSystemNotification(item) {
            this.correspondenceDialogObject.transferId = item.transferId;
            this.correspondenceDialogObject.documentId = item.documentId;
            this.correspondenceDialogOpened = true;
            this.SystemNotificationDialog = false;
        },
        OpenTaskNotification(item) {
            if (item.projectId != null && item.projectId != undefined && item.projectId > 0) {
                this.taskDialogObject.projectId = item.projectId;
                this.taskDialogObject.linkedWithProject = true;
                this.taskDialogObject.isProjectCreator = false
                this.taskDialogObject.isPublic = false;
            } else {
                this.taskDialogObject.projectId = 0;
                this.taskDialogObject.linkedWithProject = false;
                this.taskDialogObject.isProjectCreator = false;
                this.taskDialogObject.isPublic = false;
            }

            if (item.taskId != null && item.taskId != undefined && item.taskId > 0) {
                this.taskDialogObject.selectedTaskId = item.taskId;
                this.TaskDetailsDialogOpened = true;
            } else {
                this.TaskProjecDialogOpened = true;
            }
            this.SystemNotificationDialog = false;
        },
        CloseCorrespondenceDialog() {
            this.correspondenceDialogObject.transferId = this.correspondenceDialogObject.documentId = this.correspondenceDialogObject.delegationId = 0;
            this.correspondenceDialogOpened = false;
        },
        startNotificationsTimer() {
            this.GetAllSystemNotifications();
            setInterval(() => { this.GetAllSystemNotifications() }, constants.refreshSystemNotificationTimer);
        },
        clearNotificationsTimer() {
            clearInterval(this.notificationTimer);
        },
        addFloatingDisclaimer(msg) {
            const disclaimerDiv = document.createElement('div')
            disclaimerDiv.classList.add('floating-disclaimer')
            disclaimerDiv.innerHTML = msg
            disclaimerDiv.style.position = 'fixed'
            disclaimerDiv.style.top = '0'
            disclaimerDiv.style.left = '25%'
            disclaimerDiv.style.width = '50%'
            disclaimerDiv.style.background = 'rgba(255, 255, 255, 0.8)'
            disclaimerDiv.style.padding = '10px'
            disclaimerDiv.style.textAlign = 'center'
            disclaimerDiv.style.zIndex = '9999'
            disclaimerDiv.style.color = 'red'
            disclaimerDiv.style.fontSize = '16px'
            document.body.appendChild(disclaimerDiv)
        },
        applyFilters(updatedFilters, isSimpleSearch) {
            this.navigateToMyTasksAndSearch();
        },
        navigateAndSearch(updatedFilters) {
            sessionStorage.setItem('advanced_search_filters', JSON.stringify(updatedFilters));

            router.push({ path: 'AdvancedSearch', query: { fromSession: true, r: new Date().getTime().toString() } })
        },
        navigateToMyTasksAndSearch() {
            router.push({ path: 'tasks', query: { SearchQuery: this.searchQuery } })
        },
        openCreateIncomingPopup() {
            this.createByFileTitle = this.translate("res_MenuItems_CreateIncoming")
            this.createIncomingDialog = true
        }
    }
}
</script>

<style scoped>
.blue-dot {
    width: 8px;
    height: 8px;
    background-color: #205cdf;
    border-radius: 50%;
    display: inline-block;
    margin-right: 5px;
}

.red-dot {
    width: 8px;
    height: 8px;
    background-color: red;
    border-radius: 50%;
    position: absolute;
    bottom: 18px;
    right: 5px;
}

.card-scroll {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
}

.profile-icons {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-around;
    text-decoration: none;
}

.profile-icons-container:hover {
    background-color: #eff2f5;
}

.expand-advance-search {
    padding: 0px 8px;
    margin: 0px 0px;
    border-radius: 4px;
    background-color: #698bb8;
}

.profileIconsCustom {
    text-align: center;
}

.profileIconsCustom .v-icon::before {
    font-size: 27px;
}
</style>